import React from 'react';
import {
    TableWrapper,
    TableTitle,
    StyledTableContainer,
    StyledTable,
    StyledTableHead,
    StyledTableBody,
    StyledTableRow,
    StyledTableHeaderCell,
    StyledTableCell,
} from './style';

const PopulationGrowthTable = ({ data, title }) => {
    const getTableData = () => {
        if (!data) return [];

        const ageGroups = ['0~9세', '10~19세', '20~29세', '30~39세', '40~49세', '50~59세', '60세 이상'];
        const population = data.population;
        const growthRate = data.growthRate;

        // 총 인구수 계산
        const totalPopulation = population.reduce((sum, pop) => sum + pop, 0);

        return ageGroups.map((ageGroup, index) => {
            const pop = population[index];
            const percentage = totalPopulation > 0 ? (pop / totalPopulation) * 100 : 0;

            return {
                ageGroup,
                population: pop,
                percentage: percentage,
                growthRate: growthRate[index],
            };
        });
    };

    const tableData = getTableData();

    if (!data || !title) return null;

    return (
        <TableWrapper>
            <TableTitle>{title}</TableTitle>
            <StyledTableContainer>
                <StyledTable>
                    <StyledTableHead>
                        <StyledTableRow>
                            <StyledTableHeaderCell>연령대</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">인구수</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">점유율 (%)</StyledTableHeaderCell>
                            <StyledTableHeaderCell align="right">증감률 (%)</StyledTableHeaderCell>
                        </StyledTableRow>
                    </StyledTableHead>
                    <StyledTableBody>
                        {tableData.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell fontWeight="medium">{row.ageGroup}</StyledTableCell>
                                <StyledTableCell align="right">{row.population.toLocaleString()}명</StyledTableCell>
                                <StyledTableCell align="right">{row.percentage.toFixed(1)}%</StyledTableCell>
                                <StyledTableCell
                                    align="right"
                                    color={row.growthRate > 0 ? '#2e7d32' : row.growthRate < 0 ? '#d32f2f' : '#333'}
                                    fontWeight="medium"
                                >
                                    {row.growthRate > 0 ? '+' : ''}
                                    {row.growthRate}%
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </StyledTableBody>
                </StyledTable>
            </StyledTableContainer>
        </TableWrapper>
    );
};

export default PopulationGrowthTable;
